import axios from 'axios'
import { apiURL } from '../../config'

export const http = axios.create({
  baseURL: apiURL
})

/**
* Helper method to set the header with the token
*/
export function setToken (token) {
  http.defaults.headers.common.Authorization = `Bearer ${token}`
}

export default function install (Vue) {
  Object.defineProperties(Vue.prototype, {
    $http: {
      get () {
        return http
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/plugins/http/index.js